import { useQuery } from '@tanstack/react-query';
import { createSession, type SessionResponse } from '../api/sessions';

/** Re-mint well inside the shortest server-side lifetime (1h in dev mode) so an open page never goes stale. */
const RENEW_INTERVAL_MS = 10 * 60_000;

/**
 * Ensures the browser holds a live `ailab_session` cookie before a static sub-project iframe loads.
 * Call it only from the component that renders the iframe. A background re-mint keeps the cookie fresh
 * while the page stays open; `data` survives the refetch, so the iframe isn't reloaded.
 */
export function useStaticSession() {
  return useQuery<SessionResponse>({
    queryKey: ['static-session'],
    queryFn: createSession,
    staleTime: RENEW_INTERVAL_MS,
    refetchInterval: RENEW_INTERVAL_MS,
    retry: false,
  });
}
